import React, { useContext, useEffect, useState } from "react";
import { TextField, Typography, Box, Tooltip, IconButton } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import WidgetsIcon from "@mui/icons-material/Widgets";
import DashboardWidgetsPage from "./DashboardWidgetsPage.js";
import { useSelector } from "react-redux";
import InputField from "../../../CommonComponents/InputField";
import CustomDropDown from "../../../CommonComponents/CustomDropDown";
import CustomButton from "../../../CommonComponents/CustomButton";
import { ThemeContext } from "../../../Homepage";
import {
  getdashboarlist,
  getdashboardgrouplist,
  createdashboardgroup,
  updatedashboardgroup,
  deleteDashboardgroup,
  createdashboardname,
  updadashboardname,
  updateDashboard,
  deletedahboard,
  updatedashboardwidgetlist,
  getdashboarddetailseditor,
  cloneDashboard,
} from "../../../../Restclient/datacollection";
import LK_DeleteIcon from "../../../../images/LK_Delete.svg";
import LK_CloneIcon from "../../../../images/LK_Clone.svg";
import LK_Export from "../../../../images/LK_Export.svg";
import LK_Folder from "../../../../images/LK_Folder.svg";
import CustomDialogBox from "../../../CommonComponents/CustomDialogBox";
import CustomCancelButton from "../../../CommonComponents/CustomCancelButton";
import { generateWidgetId } from "./Widget/utils/widgetId.js";
import { iconBtnSx } from "./Widget/utils/widgetStyleTokens.js";

export default function DashboardList() {
  // Use mock data for local state
  const [groups, setGroups] = useState([]);
  const [dashboards, setDashboards] = useState([]);


  // Get org/project from redux
  const { Organizationid } = useSelector(
    (state) => state.logindata.userdetails || {}
  );
  // const { selectedprojectname: Projectid } = useSelector((state) => state.mainpagedata || {});
  const { selectedprojectname: Projectid } = useSelector(
    (state) => state.mainpagedata
  );

  // Fetch dashboard groups and dashboards from backend on mount
  useEffect(() => {
    if (!Organizationid || !Projectid) return;
    // Fetch groups
    getdashboardgrouplist(Organizationid, Projectid, (res) => {
      if (res && Array.isArray(res.dashboardgrouplist)) {
        setGroups(res.dashboardgrouplist);
      } else {
        setGroups([]);
      }
    });
    // Fetch dashboards
    getdashboarlist(Organizationid, Projectid, "All", (res) => {
      if (res && Array.isArray(res.dashboardlist)) {
        setDashboards(
          res.dashboardlist.map((d) => ({
            ...d,
            id: d.dashboard_pro || d.id || d.Dashboardname,
            name: d.Dashboardname || d.name,
            groupid: d.groupid,
            widgets: d.widgets || [],
            isNew: d.isNew === true,
          }))
        );
      } else {
        setDashboards([]);
      }
    });
  }, [Organizationid, Projectid]);

  const { theme } = useContext(ThemeContext);
  // Group state
  const [selectedGroup, setSelectedGroup] = useState("");
  const [addGroupDialogOpen, setAddGroupDialogOpen] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [editGroupId, setEditGroupId] = useState(null);
  const [deleteGroupDialogOpen, setDeleteGroupDialogOpen] = useState(false);
  const [groupToDelete, setGroupToDelete] = useState(null);

  // Dashboard state
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [dashboardName, setDashboardName] = useState("");

  // Helpers to cleanly open/close Add Dashboard dialog resetting state
  const openAddDialog = () => {
    setDashboardName("");
    setDashboardGroup("");
    setAddNameError("");
    setAddGroupError("");
    setAddEditError("");
    setAddDialogOpen(true);
  };

  const closeAddDialog = () => {
    setAddDialogOpen(false);
    setDashboardName("");
    setDashboardGroup("");
    setAddNameError("");
    setAddGroupError("");
    setAddEditError("");
  };
  const [dashboardGroup, setDashboardGroup] = useState("");
  const [editDashboardId, setEditDashboardId] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [dashboardToDelete, setDashboardToDelete] = useState(null);

  // Dashboard details popup
  const [dashboardDetailsOpen, setDashboardDetailsOpen] = useState(false);
  const [selectedDashboard, setSelectedDashboard] = useState(null);

  // Clone dialog state
  const [cloneDialogOpen, setCloneDialogOpen] = useState(false);
  const [cloneDashboardName, setCloneDashboardName] = useState("");
  const [cloneDashboardGroup, setCloneDashboardGroup] = useState("");
  const [cloneError, setCloneError] = useState("");
  const [cloneNameError, setCloneNameError] = useState("");
  const [cloneGroupError, setCloneGroupError] = useState("");
  // Track source dashboard & loading state during deep clone
  const [cloneSourceDashboard, setCloneSourceDashboard] = useState(null);
  const [cloneLoading, setCloneLoading] = useState(false);

  // Add/Edit error state
  const [addEditError, setAddEditError] = useState("");
  const [addNameError, setAddNameError] = useState("");
  const [addGroupError, setAddGroupError] = useState("");

  // Search state
  const [searchTerm, setSearchTerm] = useState("");

  // Widget page state
  const [showWidgetsPage, setShowWidgetsPage] = useState(false);
  const [dashboardForWidgets, setDashboardForWidgets] = useState(null);
  const [widgetsLoading, setWidgetsLoading] = useState(false);
  const [fetchedWidgets, setFetchedWidgets] = useState([]);

  // Widget management state
  const [widgetDialogOpen, setWidgetDialogOpen] = useState(false);
  const [widgetEditMode, setWidgetEditMode] = useState(false);
  const [widgetName, setWidgetName] = useState("");
  const [widgetType, setWidgetType] = useState("");
  const [widgetError, setWidgetError] = useState("");
  const [selectedWidget, setSelectedWidget] = useState(null);
  const [dashboardWidgets, setDashboardWidgets] = useState([]);
  // Dashboard operation states
  const [dashOpLoading, setDashOpLoading] = useState(false);
  const [dashOpError, setDashOpError] = useState("");
  const [groupOpError, setGroupOpError] = useState("");

  // Import dialog state
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  // Export All loading state
  const [exportAllLoading, setExportAllLoading] = useState(false);
  // Import persistent states
  const [importing, setImporting] = useState(false);
  const [importSummary, setImportSummary] = useState(null);

  // Helper: Check if name exists (case-insensitive, excluding optional id)
  const isNameExists = (name, excludeId = null) => {
    return dashboards.some(
      (d) =>
        d.name.trim().toLowerCase() === name.trim().toLowerCase() &&
        (excludeId === null || d.id !== excludeId)
    );
  };

  // Helper: refresh dashboards
  const refreshDashboards = (groupScope = "All", cb) => {
    if (!Organizationid || !Projectid) return;
    getdashboarlist(Organizationid, Projectid, groupScope, (res) => {
      if (res && Array.isArray(res.dashboardlist)) {
        const mapped = res.dashboardlist.map((d) => ({
          ...d,
          id: d.dashboard_pro || d.id || d.Dashboardname,
          name: d.Dashboardname || d.name,
          groupid: d.groupid,
          widgets: d.widgets || [],
          isNew: d.isNew === true,
        }));
        setDashboards(mapped);
        cb && cb(mapped);
      } else {
        setDashboards([]);
        cb && cb([]);
      }
    });
  };

  // Add Dashboard
  const handleAddDashboard = () => {
    setAddNameError("");
    setAddGroupError("");
    let invalid = false;
    if (!dashboardName) {
      setAddNameError("Dashboard name is required");
      invalid = true;
    }
    if (!dashboardGroup) {
      setAddGroupError("Group is required");
      invalid = true;
    }
    if (invalid) return;
    if (isNameExists(dashboardName)) {
      setAddEditError(
        "Dashboard with this name already exists, please give a unique name."
      );
      return;
    }
    setDashOpLoading(true);
    setDashOpError("");
    createdashboardname(
      Organizationid,
      Projectid,
      dashboardGroup,
      dashboardName,
      (res) => {
        const success = res && (res.success || res.status === "done");
        if (!success) {
          setAddEditError(res?.message || "Failed to add dashboard");
          setDashOpLoading(false);
          return;
        }
        refreshDashboards("All", () => {
          setDashboardName("");
          setDashboardGroup("");
          setAddDialogOpen(false); // ensure modal closes on success
          setAddEditError("");
          setDashOpLoading(false);
        });
      }
    );
  };

  // Edit Dashboard
  const openEditDialog = (dashboard) => {
    setEditDashboardId(dashboard.id);
    setDashboardName(dashboard.name);
    setDashboardGroup(dashboard.groupid); // <-- use groupid
    setEditDialogOpen(true);
    setAddEditError("");
  };

  const handleEditDashboard = () => {
    if (!dashboardName || !dashboardGroup) return;
    if (isNameExists(dashboardName, editDashboardId)) {
      setAddEditError(
        "Dashboard with this name already exists, please give a unique name."
      );
      return;
    }
    const original = dashboards.find((d) => d.id === editDashboardId);
    const nameChanged = original && original.name !== dashboardName;
    const groupChanged = original && original.groupid !== dashboardGroup;

    // If nothing changed just close
    if (!nameChanged && !groupChanged) {
      setEditDialogOpen(false);
      setEditDashboardId(null);
      setDashboardName("");
      setDashboardGroup("");
      return;
    }
    // Optimistic local update
    setDashboards((prev) =>
      prev.map((d) =>
        d.id === editDashboardId
          ? { ...d, name: dashboardName, groupid: dashboardGroup }
          : d
      )
    );
    setEditDialogOpen(false);
    setAddEditError("");
    setDashOpLoading(true);
    setDashOpError("");

    // Unified update: call updateDashboard with whichever fields changed
    updateDashboard(
      editDashboardId,
      {
        // Backend requires newname always; use original name if unchanged
        newname: dashboardName,
        newgroupid: groupChanged ? dashboardGroup : undefined,
      },
      (res) => {
        if (!(res && (res.success || res.status === "done"))) {
          setDashOpError(res?.message || "Failed to update dashboard");
        }
        refreshDashboards("All", () => setDashOpLoading(false));
      }
    );
    // Reset edit identifiers after kicking off async flow
    setEditDashboardId(null);
    setDashboardName("");
    setDashboardGroup("");
  };

  // Delete Dashboard
  const handleDeleteDashboard = () => {
    if (!dashboardToDelete) return;
    const toRemoveId = dashboardToDelete.id;
    // Optimistic removal
    setDashboards((prev) => prev.filter((d) => d.id !== toRemoveId));
    setDeleteDialogOpen(false);
    setDashboardToDelete(null);
    deletedahboard(
      { key: toRemoveId, dashboardname: dashboardToDelete?.name },
      () => {
        // Always refresh after backend response to ensure consistency
        refreshDashboards("All");
      }
    );
  };

  // Clone Dashboard
  const handleClone = (dashboard) => {
    setCloneDashboardName(dashboard.name + " (Clone)");
    setCloneDashboardGroup(dashboard.groupid);
    setCloneDialogOpen(true);
    setCloneError("");
    setCloneSourceDashboard(dashboard); // store source for deep clone
  };

  const handleCloneSave = () => {
    setCloneNameError("");
    setCloneGroupError("");
    let invalid = false;
    if (!cloneDashboardName) {
      setCloneNameError("Dashboard name is required");
      invalid = true;
    }
    if (!cloneDashboardGroup) {
      setCloneGroupError("Group is required");
      invalid = true;
    }
    if (invalid) return;
    if (isNameExists(cloneDashboardName)) {
      setCloneError(
        "Dashboard with this name already exists, please give a unique name."
      );
      return;
    }
    if (!cloneSourceDashboard) {
      setCloneError("No source dashboard selected.");
      return;
    }
    setCloneLoading(true);
    setCloneError("");
    const sourceId =
      cloneSourceDashboard.dashboard_pro || cloneSourceDashboard.id;
    // Try backend atomic clone first
    cloneDashboard(
      Organizationid,
      Projectid,
      sourceId,
      cloneDashboardGroup,
      cloneDashboardName,
      (res) => {
        const backendOk = res && (res.status === "done" || res.success);
        if (backendOk) {
          refreshDashboards("All", () => {
            setCloneDialogOpen(false);
            setCloneDashboardName("");
            setCloneDashboardGroup("");
            setCloneSourceDashboard(null);
            setCloneLoading(false);
          });
          return;
        }
        // Fallback: legacy create + client-side deep copy
        createdashboardname(
          Organizationid,
          Projectid,
          cloneDashboardGroup,
          cloneDashboardName,
          (createRes) => {
            const success =
              createRes && (createRes.success || createRes.status === "done");
            if (!success) {
              setCloneError(
                createRes?.message || "Failed to create cloned dashboard"
              );
              setCloneLoading(false);
              return;
            }
            refreshDashboards("All", (list) => {
              const newDash = list.find(
                (d) =>
                  d.name === cloneDashboardName &&
                  d.groupid === cloneDashboardGroup
              );
              if (!newDash) {
                setCloneError("New cloned dashboard not found after creation.");
                setCloneLoading(false);
                return;
              }
              const sourceWidgets = cloneSourceDashboard.widgets || [];
              const existingIds = sourceWidgets.map((w) => w.id);
              const clonedWidgets = sourceWidgets.map((w, idx) => ({
                ...w,
                id: generateWidgetId(
                  (w.widgetname || w.widgetName || "Widget") + "_clone_" + idx,
                  existingIds
                ),
                widgetname:
                  (w.widgetname || w.widgetName || "Widget") + " (Clone)",
                props: w.props ? JSON.parse(JSON.stringify(w.props)) : {},
              }));
              if (!clonedWidgets.length) {
                setCloneDialogOpen(false);
                setCloneDashboardName("");
                setCloneDashboardGroup("");
                setCloneSourceDashboard(null);
                setCloneLoading(false);
                return;
              }
              updatedashboardwidgetlist(newDash.id, clonedWidgets, (wRes) => {
                const wSuccess =
                  wRes && (wRes.success || wRes.status === "done");
                if (!wSuccess) {
                  setCloneError(
                    wRes?.message || "Failed to persist cloned widgets"
                  );
                  setCloneLoading(false);
                  return;
                }
                refreshDashboards("All", () => {
                  setCloneDialogOpen(false);
                  setCloneDashboardName("");
                  setCloneDashboardGroup("");
                  setCloneSourceDashboard(null);
                  setCloneLoading(false);
                });
              });
            });
          }
        );
      }
    );
  };

  // Manage Groups (Unified Add / Edit)
  const handleSaveGroup = () => {
    if (!groupName) return;
  
    if (editGroupId) {
      // Update existing group
      setGroupOpError("");
      updatedashboardgroup(
        Organizationid,
        Projectid,
        editGroupId,
        groupName,
        (res) => {
          if (!(res && res.status === "done")) {
            setGroupOpError(res?.message || "Failed to update group");
          } else {
            // Clear input on success
            setGroupName("");
            setEditGroupId(null);
          }
          // Refresh group list regardless of success to stay in sync
          getdashboardgrouplist(Organizationid, Projectid, (groupRes) => {
            if (groupRes && Array.isArray(groupRes.dashboardgrouplist)) {
              setGroups(groupRes.dashboardgrouplist);
            } else {
              setGroups([]);
            }
          });
        }
      );
    } else {
      // Create new group
      setGroupOpError("");
      createdashboardgroup(Organizationid, Projectid, groupName, (res) => {
        if (!(res && res.status === "done")) {
          setGroupOpError(res?.message || "Failed to create group");
        } else {
          setGroupName("");
        }
        getdashboardgrouplist(Organizationid, Projectid, (groupRes) => {
          if (groupRes && Array.isArray(groupRes.dashboardgrouplist)) {
            setGroups(groupRes.dashboardgrouplist);
          } else {
            setGroups([]);
          }
        });
      });
    }
  };

  const openEditGroupDialog = (group) => {
    setEditGroupId(group.groupid);
    setGroupName(group.groupname);
  };

  // (Legacy separate edit handler removed – unified into handleSaveGroup)

  const handleDeleteGroup = () => {
    if (!groupToDelete) return;
    deleteDashboardgroup(
      Organizationid,
      Projectid,
      groupToDelete.groupid,
      (res) => {
        setDeleteGroupDialogOpen(false);
        setGroupToDelete(null);
        // Always fetch latest groups after delete attempt
        getdashboardgrouplist(Organizationid, Projectid, (groupRes) => {
          if (groupRes && Array.isArray(groupRes.dashboardgrouplist)) {
            setGroups(groupRes.dashboardgrouplist);
          } else {
            setGroups([]);
          }
        });
        // Optionally show error if needed
      }
    );
  };

  // Dashboard row click
  const handleDashboardRowClick = (dashboard) => {
    setSelectedDashboard({ ...dashboard }); // create a fresh copy
    setDashboardDetailsOpen(true);
  };

  // Export dashboard as JSON (including its latest widgets fetched from backend)
  const handleExportDashboard = async (dashboard) => {
    try {
      // Reuse helper to fetch normalized widgets for the specific dashboard
      const full = await fetchDashboardWidgetsForExport(dashboard);
      const dataStr =
        "data:text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(full, null, 2));
      const downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute(
        "download",
        `${(dashboard.name || dashboard.Dashboardname || "dashboard")
          .toString()
          .replace(/\s+/g, "_")}.json`
      );
      document.body.appendChild(downloadAnchorNode);
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    } catch (_) {
      // Fallback to exporting the in-memory shape if fetch fails
      const safe = {
        ...dashboard,
        widgets: Array.isArray(dashboard.widgets) ? dashboard.widgets : [],
      };
      const dataStr =
        "data:text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(safe, null, 2));
      const downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute(
        "download",
        `${(dashboard.name || dashboard.Dashboardname || "dashboard")
          .toString()
          .replace(/\s+/g, "_")}.json`
      );
      document.body.appendChild(downloadAnchorNode);
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    }
  };

  // Filter dashboards by search term (case-insensitive)
  const filteredDashboards = dashboards.filter((d) =>
    d.name.toLowerCase().includes(searchTerm.trim().toLowerCase())
  );

  // Helper: fetch a single dashboard's widgets (normalized) for export
  const fetchDashboardWidgetsForExport = (dashboard) =>
    new Promise((resolve) => {
      const dashIdParam = dashboard.dashboard_pro || dashboard.id;
      getdashboarddetailseditor(dashIdParam, (res) => {
        try {
          const root = res?.dashboardjson || res;
          const dj = root?.DashboardJSON || root?.dashboard || root;
          let list =
            dj?.widgetlist ||
            dj?.widgets ||
            root?.widgetlist ||
            root?.widgets ||
            [];
          if (list && list.list && Array.isArray(list.list)) list = list.list;
          if (!Array.isArray(list)) list = [];
          // Keep original widget objects as-is (no renaming) for export fidelity
          resolve({ ...dashboard, widgets: list });
        } catch (e) {
          resolve({ ...dashboard, widgets: [] });
        }
      });
    });

  // Export all dashboards with their widgets (fresh fetch per dashboard)
  const handleExportAllDashboards = async () => {
    if (!dashboards.length) return;
    setExportAllLoading(true);
    try {
      const fullDashboardsRaw = await Promise.all(
        dashboards.map(fetchDashboardWidgetsForExport)
      );
      // add groupname for reliable re-import
      const fullDashboards = fullDashboardsRaw.map((d) => {
        const group = groups.find((g) => g.groupid === d.groupid);
        return { ...d, groupname: group?.groupname || "" };
      });
      const dataStr =
        "data:text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(fullDashboards, null, 2));
      const downloadAnchorNode = document.createElement("a");
      downloadAnchorNode.setAttribute("href", dataStr);
      downloadAnchorNode.setAttribute(
        "download",
        "all_dashboards_with_widgets.json"
      );
      document.body.appendChild(downloadAnchorNode);
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    } finally {
      setExportAllLoading(false);
    }
  };

  // Fix: getGroupName should use groupid, not groupname
  const getGroupName = (groupid) => {
    const group = groups.find((g) => g.groupid === groupid);
    return group ? group.groupname : "";
  };

  // Open widget dialog for selected dashboard
  const handleOpenWidgetDialog = (dashboard) => {
    setDashboardWidgets(dashboard.widgets || []);
    setSelectedDashboard(dashboard);
    setWidgetDialogOpen(true);
    setWidgetEditMode(false);
    setWidgetName("");
    setWidgetType("");
    setWidgetError("");
    setSelectedWidget(null);
  };

  // Normalize backend widget shape to existing internal shape used by Widget components
  const normalizeIncomingWidget = (w) => ({
    id: w.id || w.widgetid || Date.now() + Math.random(),
    widgetName:
      w.widgetname ||
      w.props?.basic?.widgetName ||
      w.props?.basic?.title ||
      "Widget",
    type: w.type,
    props: {
      basic: w.props?.basic || w.basicProps || {},
      extended: w.props?.extended || w.extendedProps || {},
    },
  });

  const openWidgetsPage = (d) => {
    setWidgetsLoading(true);
    setDashboardForWidgets(d);
    const dashIdParam = d.dashboard_pro || d.id; // backend may require dashboard_pro
    getdashboarddetailseditor(dashIdParam, (res) => {
      try {
        const root = res?.dashboardjson || res;
        const dj = root?.DashboardJSON || root?.dashboard || root;
        let list =
          dj?.widgetlist ||
          dj?.widgets ||
          root?.widgetlist ||
          root?.widgets ||
          [];
        // Some backends wrap widgets under an object property 'list'
        if (list && list.list && Array.isArray(list.list)) list = list.list;
        if (!Array.isArray(list)) list = [];
        const normalized = list.map(normalizeIncomingWidget);
        setFetchedWidgets(normalized);
      } catch (e) {
        setFetchedWidgets([]);
      } finally {
        setShowWidgetsPage(true);
        setWidgetsLoading(false);
      }
    });
  };

  // Add widget to dashboard
  const handleAddWidget = () => {
    if (!widgetName || !widgetType) {
      setWidgetError("Widget name and type are required.");
      return;
    }
    if (
      dashboardWidgets.some(
        (w) =>
          w.widgetname.trim().toLowerCase() === widgetName.trim().toLowerCase()
      )
    ) {
      setWidgetError("Widget with this name already exists in this dashboard.");
      return;
    }
    const existingIds = dashboardWidgets.map((w) => w.id);
    const newId = generateWidgetId(widgetName, existingIds);
    const newWidgets = [
      ...dashboardWidgets,
      {
        id: newId,
        widgetname: widgetName,
        type: widgetType,
        props: { basic: { height: "300px" } },
      },
    ];
    setDashboardWidgets(newWidgets);
    setWidgetName("");
    setWidgetType("");
    setWidgetError("");
  };

  // Edit widget
  const handleEditWidget = (widget) => {
    setWidgetEditMode(true);
    setWidgetName(widget.widgetname);
    setWidgetType(widget.type);
    setSelectedWidget(widget);
    setWidgetError("");
  };

  const handleSaveWidgetEdit = () => {
    if (!widgetName || !widgetType) {
      setWidgetError("Widget name and type are required.");
      return;
    }
    if (
      dashboardWidgets.some(
        (w) =>
          w.widgetname.trim().toLowerCase() ===
            widgetName.trim().toLowerCase() && w.id !== selectedWidget.id
      )
    ) {
      setWidgetError("Widget with this name already exists in this dashboard.");
      return;
    }
    const updatedWidgets = dashboardWidgets.map((w) =>
      w.id === selectedWidget.id
        ? { ...w, widgetname: widgetName, type: widgetType }
        : w
    );
    setDashboardWidgets(updatedWidgets);
    setWidgetEditMode(false);
    setWidgetName("");
    setWidgetType("");
    setSelectedWidget(null);
    setWidgetError("");
  };

  // Delete widget
  const handleDeleteWidget = (widget) => {
    setDashboardWidgets(dashboardWidgets.filter((w) => w.id !== widget.id));
  };

  // Save widgets to dashboard
  const handleSaveWidgetsToDashboard = () => {
    if (!selectedDashboard) return;
    setDashOpLoading(true);
    setDashOpError("");
    // Persist widgets to backend, then update local state via refresh
    // Preflight validation
    const missing = dashboardWidgets.filter((w) => !w.id || !w.type);
    if (missing.length) {
      setDashOpError(
        `Cannot save: ${missing.length} widget(s) missing ${
          missing[0].id ? "type" : "id"
        } field.`
      );
      setDashOpLoading(false);
      return;
    }
    updatedashboardwidgetlist(selectedDashboard.id, dashboardWidgets, (res) => {
      const status = res?.status || (res?.success ? "done" : "fail");
      if (status !== "done") {
        setDashOpError(res?.message || res?.reason || "Failed to save widgets");
      } else {
        // Update local state only on success to avoid divergence
        setDashboards(
          dashboards.map((d) =>
            d.id === selectedDashboard.id
              ? { ...d, widgets: dashboardWidgets }
              : d
          )
        );
        setWidgetDialogOpen(false);
        refreshDashboards("All");
      }
      setDashOpLoading(false);
    });
  };

  // Promise wrappers for existing callbacks
  const apiCreateGroup = (orgId, projId, name) =>
    new Promise((resolve) => {
      createdashboardgroup(orgId, projId, name, (res) => resolve(res));
    });
  const apiListGroups = (orgId, projId) =>
    new Promise((resolve) => {
      getdashboardgrouplist(orgId, projId, (res) => resolve(res));
    });
  const apiCreateDashboard = (orgId, projId, groupId, name) =>
    new Promise((resolve) => {
      createdashboardname(orgId, projId, groupId, name, (res) => resolve(res));
    });
  const apiListDashboards = (orgId, projId, scope = "All") =>
    new Promise((resolve) => {
      getdashboarlist(orgId, projId, scope, (res) => resolve(res));
    });
  const apiSaveWidgets = (dashId, widgets) =>
    new Promise((resolve) => {
      updatedashboardwidgetlist(dashId, widgets, (res) => resolve(res));
    });

  // Persistent import logic
  const handleImportDashboard = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        setImportSummary(null);
        const raw = JSON.parse(e.target.result);
        const arr = Array.isArray(raw) ? raw : [raw];
        // Normalize minimal shape
        const normalized = arr
          .filter((d) => d.name && (d.groupid || d.groupname))
          .map((d) => ({
            name: (d.name || "").trim(),
            groupid: d.groupid || null,
            groupname: d.groupname || null,
            widgets: Array.isArray(d.widgets) ? d.widgets : [],
          }));
        if (!normalized.length) {
          alert("No valid dashboards to import.");
          return;
        }
        setImporting(true);
        const results = [];
        // Latest groups snapshot
        let currentGroups = groups.slice();
        const ensureGroup = async (groupId, groupName) => {
          if (groupId && currentGroups.some((g) => g.groupid === groupId))
            return groupId;
          if (groupName) {
            const existing = currentGroups.find(
              (g) => g.groupname.toLowerCase() === groupName.toLowerCase()
            );
            if (existing) return existing.groupid;
            const cgRes = await apiCreateGroup(
              Organizationid,
              Projectid,
              groupName
            );
            if (!(cgRes && cgRes.status === "done")) return null;
            const listRes = await apiListGroups(Organizationid, Projectid);
            if (listRes && Array.isArray(listRes.dashboardgrouplist)) {
              currentGroups = listRes.dashboardgrouplist;
              const created = currentGroups.find(
                (g) => g.groupname.toLowerCase() === groupName.toLowerCase()
              );
              return created ? created.groupid : null;
            }
            return null;
          }
          return null;
        };
        for (const dash of normalized) {
          // Duplicate check (current in-memory + already created in this run)
          const duplicate = dashboards
            .concat(
              results
                .filter((r) => r.newName)
                .map((r) => ({ name: r.newName, groupid: r.groupid }))
            )
            .some(
              (d) =>
                d.name.trim().toLowerCase() === dash.name.toLowerCase() &&
                d.groupid ===
                  (dash.groupid ||
                    currentGroups.find(
                      (g) =>
                        g.groupname?.toLowerCase() ===
                        dash.groupname?.toLowerCase()
                    )?.groupid)
            );
          if (duplicate) {
            results.push({
              name: dash.name,
              status: "skip",
              reason: "duplicate",
            });
            continue;
          }
          const groupIdResolved = await ensureGroup(
            dash.groupid,
            dash.groupname || "Imported"
          );
          if (!groupIdResolved) {
            results.push({
              name: dash.name,
              status: "fail",
              reason: "group create/resolve failed",
            });
            continue;
          }
          const cdRes = await apiCreateDashboard(
            Organizationid,
            Projectid,
            groupIdResolved,
            dash.name
          );
          if (!(cdRes && (cdRes.status === "done" || cdRes.success))) {
            results.push({
              name: dash.name,
              status: "fail",
              reason: "dashboard create failed",
            });
            continue;
          }
          // Fetch dashboards to locate new id
          const listRes = await apiListDashboards(
            Organizationid,
            Projectid,
            "All"
          );
          let newId = null;
          if (listRes && Array.isArray(listRes.dashboardlist)) {
            const found = listRes.dashboardlist.find(
              (d) =>
                (d.Dashboardname || d.name) === dash.name &&
                d.groupid === groupIdResolved
            );
            if (found)
              newId = found.dashboard_pro || found.id || found.Dashboardname;
          }
          if (!newId) {
            results.push({
              name: dash.name,
              status: "fail",
              reason: "new id not found",
            });
            continue;
          }
          // Prepare widgets
          const wList = dash.widgets
            .map((w, idx) => {
              const wName =
                w.widgetname || w.widgetName || w.name || `Widget ${idx + 1}`;
              return {
                id: generateWidgetId(
                  wName + "_imp_" + idx,
                  dash.widgets.map((x) => x.id).filter(Boolean)
                ),
                widgetname: wName,
                type: w.type,
                props: w.props || {
                  basic: w.basicProps || {},
                  extended: w.extendedProps || {},
                },
              };
            })
            .filter((w) => w.type);
          let widgetsStatus = "skipped";
          if (wList.length) {
            const swRes = await apiSaveWidgets(newId, wList);
            widgetsStatus =
              swRes && (swRes.status === "done" || swRes.success)
                ? "done"
                : "fail";
          }
          results.push({
            name: dash.name,
            status: widgetsStatus === "fail" ? "partial" : "done",
            groupid: groupIdResolved,
            widgets: wList.length,
            widgetsStatus,
          });
        }
        // Final refresh
        refreshDashboards("All");
        setImportSummary(results);
        setImportDialogOpen(false);
      } catch (err) {
        alert("Error importing dashboards: " + err.message);
      } finally {
        setImporting(false);
      }
    };
    reader.readAsText(file);
  };

  return (
    <div style={{ padding: 12 }}>
      {showWidgetsPage ? (
        <DashboardWidgetsPage
          dashboard={dashboardForWidgets}
          existingWidgets={fetchedWidgets}
          onBack={() => {
            setShowWidgetsPage(false);
            setDashboardForWidgets(null);
            setFetchedWidgets([]);
          }}
          onPersist={(savedList) => {
            setDashboards((prev) =>
              prev.map((db) =>
                db.id === dashboardForWidgets.id
                  ? { ...db, widgets: savedList }
                  : db
              )
            );
            refreshDashboards("All");
          }}
        />
      ) : (
        <>
          {/* Top Bar */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 16,
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h5"
              style={{
                color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
                fontWeight: 700,
                color: "#008CD7",
                height: "23px",
              }}
            >
              Dashboard List
            </Typography>
            <div>
              <TextField
                placeholder="Search dashboards..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                size="small"
                style={{
                  backgroundColor: theme === "light" ? "#FFFFFF" : "#1E1E1E",
                }}
                sx={{
                  width: 200,
                  // flex:0,
                  mr: 2,
                  "& .MuiOutlinedInput-root": {
                    p: 0,
                    // remove default outline completely
                    "& fieldset": { border: "none" },
                    "&:hover fieldset": { border: "none" },
                    "&.Mui-focused fieldset": { border: "none" },
                  },
                  "& .MuiInputBase-root": {
                    // backgroundColor: theme === 'light' ? '#FFFFFF' : '#1E1E1E',
                    color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
                    borderRadius: 0,
                    fontWeight: 500,
                    fontFamily: "Roboto",
                    paddingLeft: 1,
                    // custom bottom-only border
                    borderBottom: `1px solid ${
                      theme === "light" ? "#C7CED3" : "#FFFFFF"
                    }`,
                    transition: "border-color .2s",
                  },
                  "& .MuiInputBase-root:hover": {
                    borderBottom: `1px solid ${
                      theme === "light" ? "#88939B" : "#FFFFFF"
                    }`,
                  },
                  "& .MuiInputBase-root.Mui-focused": {
                    borderBottom: `2px solid ${
                      theme === "light" ? "var(--LK_BrandBlue)" : "#64B5F6"
                    }`,
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: theme === "light" ? "#6E7B87" : "#B0BEC5",
                    opacity: 1,
                  },
                }}
                InputProps={{
                  style: {
                    color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
                  },
                }}
              />
              <CustomButton
                buttonText="Add Dashboard"
                onClick={openAddDialog}
              />
              <CustomButton
                buttonText="Manage Groups"
                onClick={() => setAddGroupDialogOpen(true)}
                sx={{
                  marginLeft: "4px",
                }}
              />
              <CustomButton
                buttonText="Import"
                onClick={() => {
                  setImportDialogOpen(true);
                  setImportSummary(null);
                }}
              sx={{
                  marginLeft: "4px",
                }}
              />
              <CustomButton
                buttonText={exportAllLoading ? "Exporting..." : "Export All"}
                onClick={handleExportAllDashboards}
                disabled={exportAllLoading}
                sx={{
                  marginLeft: "4px",
                }}
              />
            </div>
          </div>
          <div style={{ width: "100%" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                tableLayout: "fixed",
              }}
            >
              <thead style={{ borderBottom: "1px solid #3A4452" }}>
                <tr style={{ textAlign: "left" }}>
                  <th
                    style={{
                      padding: 8,
                      width: "33.33%",
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#3A4452",
                    }}
                  >
                    Name
                  </th>
                  <th
                    style={{
                      padding: 8,
                      width: "33.33%",
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#3A4452",
                    }}
                  >
                    Group
                  </th>
                  <th
                    style={{
                      padding: 8,
                      width: "33.34%",
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#3A4452",
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
            </table>

            <div
              style={{
                maxHeight: "calc(100vh - 450px)",
                overflowY: "auto",
                overflowX: "hidden",
                scrollbarWidth: "thin",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                }}
              >
                <tbody>
                  {filteredDashboards.map((d) => (
                    <tr
                      key={d.id}
                      style={{ cursor: "pointer", textAlign: "left" }}
                      onClick={() => handleDashboardRowClick(d)}
                    >
                      <td
                        style={{
                          padding: "16px 8px",
                          borderBottom: "1px solid #3A4452",
                          width: "33.33%",
                          color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
                        }}
                      >
                        {d.name}
                      </td>
                      <td
                        style={{
                          padding: 8,
                          borderBottom: "1px solid #3A4452",
                          width: "33.33%",
                          color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
                        }}
                      >
                        {getGroupName(d.groupid)}
                      </td>
                      <td
                        style={{
                          padding: "4px 2px",
                          borderBottom: "1px solid #3A4452",
                          width: "33.34%",
                          color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                    {/* <Tooltip title="Edit" arrow>
                      <IconButton
                        size="small"
                        aria-label="edit"
                        sx={iconBtnSx}
                        onClick={() => openEditDialog(d)}
                        style={{
                          background: "none",
                          color: theme === "light" ? "#7E7E7E" : "#008CD7",
                          marginRight: "8px",
                          border: "none",
                        }}
                      >
                        <img
                          src={LK_ModifyEditIcon}
                          width={18}
                          height={18}
                          alt="edit"
                        />
                      </IconButton>
                    </Tooltip> */}
                    <Tooltip title="Delete" arrow>
                      <IconButton
                        size="small"
                        aria-label="delete"
                        sx={iconBtnSx}
                        onClick={() => {
                          setDashboardToDelete(d);
                          setDeleteDialogOpen(true);
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          color: theme === "light" ? "#7E7E7E" : "#008CD7",
                          marginRight: "8px",
                        }}
                      >
                        <img
                          src={LK_DeleteIcon}
                          width={18}
                          height={18}
                          alt="delete"
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Clone" arrow>
                      <IconButton
                        size="small"
                        aria-label="clone"
                        sx={iconBtnSx}
                        onClick={() => handleClone(d)}
                        style={{
                          background: "none",
                          border: "none",
                          color: theme === "dark" ? "#7E7E7E" : "#008CD7",
                          marginRight: "8px",
                        }}
                      >
                        <img
                          src={LK_CloneIcon}
                          width={18}
                          height={18}
                          alt="clone"
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Export" arrow>
                      <IconButton
                        size="small"
                        aria-label="export"
                        sx={iconBtnSx}
                        onClick={() => handleExportDashboard(d)}
                        style={{
                          background: "none",
                          border: "none",
                          color: theme === "light" ? "#7E7E7E" : "#008CD7",
                          marginRight: "8px",
                        }}
                      >
                        <img
                          src={LK_Export}
                          width={18}
                          height={18}
                          alt="export"
                        />
                      </IconButton>
                    </Tooltip>
                    {(
                      <Tooltip title="Widgets" arrow>
                        <IconButton
                          size="small"
                          aria-label="widgets"
                          sx={iconBtnSx}
                          onClick={() => openWidgetsPage(d)}
                          disabled={
                            widgetsLoading && dashboardForWidgets?.id === d.id
                          }
                          style={{
                            background: "none",
                            border: "none",
                            color: theme === "light" ? "#7E7E7E" : "#008CD7",
                            marginLeft: "2px",
                          }}
                        >
                          <img
                            src={LK_Folder}
                            width={18}
                            height={18}
                            alt="widgets"
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Add Dashboard Dialog */}
          <CustomDialogBox
            openDialog={addDialogOpen}
            handleCloseDialog={closeAddDialog}
            dialogTitle="Add Dashboard"
            confirmText={dashOpLoading ? "Saving..." : "Add"}
            cancelText="Cancel"
            handleConfirmDialog={handleAddDashboard}
            type="Info"
          >
            <InputField
              key="dashboardName"
              label="Dashboard Name"
              required={true}
              value={dashboardName}
              onChange={(e) => {
                setDashboardName(e.target.value);
                setAddEditError("");
                setAddNameError("");
              }}
              error={!!addNameError || !!addEditError}
              helperText={addNameError || addEditError}
              lineColor={theme === "light" ? "#C7CED3" : "#FFFFFF"}
              focusLineColor={theme === "light" ? "#008CD7" : "#64B5F6"}
              FormHelperTextProps={{ sx: { maxWidth: "500px" } }}
              style={{
                width: "100%",
                color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
              }}
              inputProps={{ readOnly: false }}
              errorColor={theme === "light" ? "#D32F2F" : "#FF867C"}
            />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography
                style={{
                  fontSize: "18px",
                  fontWeight: 400,
                  color: "var(--GreyVariation_2)",
                  width: "100%",
                }}
              >
                Groups
                <span
                  style={{ color: "var(--RedBaseColor, #DC272D)", marginLeft: "5px" }}
                >
                  *
                </span>
              </Typography>
              <CustomDropDown
                options={groups.map((g) => g.groupname)}
                onChange={(value) => {
                  const selectedGroup = groups.find(
                    (g) => g.groupname === value
                  );
                  setDashboardGroup(selectedGroup ? selectedGroup.groupid : "");
                }}
                width="320px"
                fontSize={14}
                disabledOptions={[]}
                style={{
                  width: "320px",
                  borderBottom: `1px solid ${
                    theme === "light" ? "#C7CED3" : "#FFFFFF"
                  }`,
                }}
              />
            </Box>
            {!!addGroupError && (
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  color: theme === "light" ? "#D32F2F" : "#FF867C",
                  fontSize: "0.75rem",
                }}
              >
                {addGroupError}
              </Typography>
            )}
            {addEditError && (
              <Typography color="error" sx={{ mt: 1 }}>
                {addEditError}
              </Typography>
            )}
          </CustomDialogBox>

          {/* Edit Dashboard Dialog */}
          <CustomDialogBox
            openDialog={editDialogOpen}
            handleCloseDialog={() => setEditDialogOpen(false)}
            dialogTitle="Edit Dashboard"
            confirmText={dashOpLoading ? "Updating..." : "Save"}
            cancelText="Cancel"
            handleConfirmDialog={handleEditDashboard}
            type="Info"
          >
            <InputField
              key="dashboardNameEdit"
              label="Dashboard Name"
              required={true}
              value={dashboardName}
              onChange={(e) => {
                setDashboardName(e.target.value);
                setAddEditError("");
              }}
              error={!!addEditError}
              helperText={addEditError}
              FormHelperTextProps={{ sx: { maxWidth: "500px" } }}
              style={{
                width: "320px",
                color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
              }}
              inputProps={{ readOnly: false }}
              errorColor={theme === "light" ? "#D32F2F" : "#FF867C"}
            />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography
                style={{
                  fontSize: "18px",
                  fontWeight: 400,
                  color: "var(--GreyVariation_2)",
                  width: "224px",
                }}
              >
                Groups
                <span
                  style={{ color: "var(--RedBaseColor, #DC272D)", marginLeft: "5px" }}
                >
                  *
                </span>
              </Typography>
              <CustomDropDown
                options={groups.map((g) => g.groupname)}
                onChange={(value) => {
                  const selectedGroup = groups.find(
                    (g) => g.groupname === value
                  );
                  setDashboardGroup(selectedGroup ? selectedGroup.groupid : "");
                }}
                defaultValue={
                  groups.find((g) => g.groupid === dashboardGroup)?.groupname ||
                  ""
                }
                width="320px"
                fontSize={14}
                disabledOptions={[]}
                style={{
                  width: "320px",
                  borderBottom: `1px solid ${
                    theme === "light" ? "#C7CED3" : "#FFFFFF"
                  }`,
                }}
              />
            </Box>
            {!dashboardGroup && (
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  color: theme === "light" ? "#D32F2F" : "#FF867C",
                  fontSize: "0.75rem",
                }}
              >
                Group is required
              </Typography>
            )}
            {addEditError && (
              <Typography color="error" sx={{ mt: 1 }}>
                {addEditError}
              </Typography>
            )}
          </CustomDialogBox>

          {/* Clone Dashboard Dialog */}
          <CustomDialogBox
            openDialog={cloneDialogOpen}
            handleCloseDialog={() => {
              if (!cloneLoading) {
                setCloneDialogOpen(false);
              }
            }}
            dialogTitle="Clone Dashboard"
            confirmText={cloneLoading ? "Cloning..." : "Save"}
            cancelText="Close"
            handleConfirmDialog={handleCloneSave}
            type="Info"
          >
            <InputField
              key="cloneDashboardName"
              label="Dashboard Name"
              required={true}
              value={cloneDashboardName}
              onChange={(e) => {
                setCloneDashboardName(e.target.value);
                setCloneError("");
              }}
              error={!!cloneError}
              helperText={cloneError}
              lineColor={theme === "light" ? "#C7CED3" : "#FFFFFF"}
              focusLineColor={theme === "light" ? "#008CD7" : "#64B5F6"}
              FormHelperTextProps={{ sx: { maxWidth: "500px" } }}
              style={{
                width: "320px",
                color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
              }}
              inputProps={{ readOnly: false }}
              errorColor={theme === "light" ? "#D32F2F" : "#FF867C"}
            />
            <Box
              sx={{ display: "flex",
                 flexDirection: "column", gap: 1, mt: 1 }}
            >
              <Typography
                style={{
                  fontSize: "18px",
                  fontWeight: 400,
                  color: "var(--GreyVariation_2)",
                  width: "224px",
                }}
              >
                Groups
                <span
                  style={{ color: "var(--RedBaseColor, #DC272D)", marginLeft: "5px" }}
                >
                  *
                </span>
              </Typography>
              <CustomDropDown
                options={groups.map((g) => g.groupname)}
                onChange={(value) => {
                  const selectedGroup = groups.find(
                    (g) => g.groupname === value
                  );
                  setCloneDashboardGroup(
                    selectedGroup ? selectedGroup.groupid : ""
                  );
                }}
                defaultValue={
                  groups.find((g) => g.groupid === cloneDashboardGroup)
                    ?.groupname || ""
                }
                width="320px"
                fontSize={14}
                disabledOptions={[]}
                style={{
                  width: "320px",
                  borderBottom: `1px solid ${
                    theme === "light" ? "#C7CED3" : "#FFFFFF"
                  }`,
                }}
              />
            </Box>
            {!cloneDashboardGroup && (
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  color: theme === "light" ? "#D32F2F" : "#FF867C",
                  fontSize: "0.75rem",
                }}
              >
                Group is required
              </Typography>
            )}
            {cloneError && (
              <Typography color="error" sx={{ mt: 1 }}>
                {cloneError}
              </Typography>
            )}
          </CustomDialogBox>

          {/* Delete Confirmation Dialog */}
          <CustomDialogBox
            openDialog={deleteDialogOpen}
            handleCloseDialog={() => setDeleteDialogOpen(false)}
            dialogTitle="Delete Dashboard"
            dialogText={`Are you sure you want to delete "${dashboardToDelete?.name}"?`}
            confirmText="Delete"
            cancelText="Cancel"
            handleConfirmDialog={handleDeleteDashboard}
            type="Error"
          />

          {/* Manage Groups Dialog */}
          <CustomDialogBox
            openDialog={addGroupDialogOpen}
            handleCloseDialog={() => setAddGroupDialogOpen(false)}
            dialogTitle="Manage Groups"
            cancelText="Close"
            type="Info"
            maxWidth="1200px"
          >
            <InputField
              key="groupName"
              label={editGroupId ? "Edit Group Name" : "New Group Name"}
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              error={false}
              helperText=""
              FormHelperTextProps={{ sx: { maxWidth: "500px" } }}
              lineColor={theme === "light" ? "#C7CED3" : "#FFFFFF"}
              focusLineColor={theme === "light" ? "#008CD7" : "#64B5F6"}
              style={{ width: "100%", 
                color: theme === 'light' ? '#7E7E7E' : '#FFFFFF',
                 fontWeight: 400, fontSize: 16, 
                borderRadius: 4,mb:4 }}
              inputProps={{ readOnly: false }}
            />
            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <CustomButton
                buttonText={editGroupId ? "Update Group" : "Add Group"}
                onClick={handleSaveGroup}
                disabled={!groupName}
                sx={{
                  marginTop: "8px",
                }}
              />
              {editGroupId && (
                <div
                style={{
                    marginTop: "8px",
                }}
                >
                  <CustomCancelButton
                    buttonText="Cancel"
                    onClick={() => {
                      setEditGroupId(null);
                      setGroupName("");
                    }}
                  />

                </div>
              )}
            </Box>
            {groupOpError && (
              <Typography color="error" variant="body2" sx={{ mb: 2 }}>
                {groupOpError}
              </Typography>
            )}
            <Typography
              variant="subtitle1"
              sx={{
                mt: 1,
                mb: 1,
                fontWeight: 600,
                color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
                pt: 2,
                fontWeight: 700,
                color: "#008CD7",
                fontSize: "18px",
              }}
            >
              Existing Groups
            </Typography>
            <Box
              sx={{
                flexGrow: 1,
                maxHeight: 300,
                overflowY: "auto",
                pr: 1,
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": { width: "6px" },
                "&::-webkit-scrollbar-track": { background: "transparent" },
                "&::-webkit-scrollbar-thumb": {
                  background: "#999",
                  borderRadius: "3px",
                },
              }}
            >
              <ul style={{ margin: 0, padding: 0, listStyle: "none" }}>
                {groups.map((g) => (
                  <li
                    key={g.groupid}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 8,
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
                      }}
                    >
                      {g.groupname}
                    </span>
                    <CustomButton
                      buttonText="Edit"
                      onClick={() => openEditGroupDialog(g)}
                    />
                    <CustomButton
                      buttonText="Delete"
                      onClick={() => {
                        setGroupToDelete(g);
                        setDeleteGroupDialogOpen(true);
                      }}
                    sx={{
                      marginLeft: "2px",
                    }}
                    />
                  </li>
                ))}
              </ul>
            </Box>
          </CustomDialogBox>

          {/* (Removed separate Edit Group Dialog – unified inline form handles both add & edit) */}

          {/* Delete Group Confirmation Dialog */}
          <CustomDialogBox
            openDialog={deleteGroupDialogOpen}
            handleCloseDialog={() => setDeleteGroupDialogOpen(false)}
            dialogTitle="Delete Group"
            dialogText={`Are you sure you want to delete group "${groupToDelete?.groupname || ""}"?`}
            confirmText="Delete"
            cancelText="Cancel"
            handleConfirmDialog={handleDeleteGroup}
            type="Error"
          />

          {/* Dashboard Details Popup */}
          <CustomDialogBox
            openDialog={dashboardDetailsOpen}
            handleCloseDialog={() => setDashboardDetailsOpen(false)}
            dialogTitle="Dashboard Details"
            cancelText="Close"
            type="Info"
          >
            <Typography variant="subtitle1">
              Name: {selectedDashboard?.name}
            </Typography>
            <Typography variant="subtitle1">
              Group: {getGroupName(selectedDashboard?.groupid)}
            </Typography>
          </CustomDialogBox>
        </>
      )}

      {/* Import Dashboards Dialog */}
      <CustomDialogBox
        openDialog={importDialogOpen}
        handleCloseDialog={() => setImportDialogOpen(false)}
        dialogTitle="Import Dashboards"
        cancelText="Cancel"
        type="Info"
      >
        <input
          type="file"
          accept=".json,application/json"
          onChange={handleImportDashboard}
          style={{ marginTop: 8 }}
        />
      </CustomDialogBox>
    </div>
  );
}
	